import { Physician } from './physician';
import { Student } from './student';

// Check this class for items that are not truly required
export class ClaimPhysician {
    id?: number;
    physicianStudent: Student | null;
    physicianSeparationReason: string;
    physicianICDDSM: string;
    physicianClassAbsenceStartDate: string;
    physicianClassAbsenceEndDate: string;
    physicianFirstConsultDate: string;
    physicianLastConsultDate: string;
    physicianHomeVisitCount: string;
    physicianOfficeVisitCount: string;
    physicianHospitalVisitCount: string;
    physicianStillUnderCare: boolean;
    physicianReferredPhysicianInfo: string;
    physicianReferringPhysicianInfo: string;
    physicianWithdrawnOnRecommendation: boolean;
    physicianWithdrawalRecommendationReason: string;
    physicianAnticipatedReturnDescription: string;
    physicianAlternateSchoolOrEmploymentDuringLeave: boolean;
    physicianWithPhysicianPermission: boolean;
    physicianAlternateActivityStartDate: string;
    physicianAlternateActivityExplanation: string;
    physician: Physician | null;
    physicianLicenseNumber: string;
    physicianSubmittedDate: string;
    physicianSignature: string;
}
